import { apiRequest } from './apiService';

// Sales Payments
export const fetchSalesPayments = async () => {
  return await apiRequest('/sales/sales-payments', 'GET');
};

export const createSalesPayment = async (paymentData: any) => {
  return await apiRequest('/sales/sales-payments', 'POST', paymentData);
};

export const deleteSalesPayment = async (id: string) => {
  return await apiRequest(`/sales/sales-payments/${id}`, 'DELETE');
};

export const updatePayment = async (id: string, data: any) => {
  return await apiRequest(`/sales/sales-payments/${id}`, 'PUT', data);
};

export const fetchPaymentById = async (id: string) => {
  return await apiRequest(`/sales/sales-payments/${id}`, 'GET');
};
